import React from 'react';
import Roadmap from '../components/Roadmap';

const RoadmapPage = () => {
  return <Roadmap />;
};

export default RoadmapPage;
